import { Geometry } from "geojson";

export interface GeoService {
	initialize(): void;
	version(): Promise<string>;
	status(): Promise<string>;
	search(request: SearchRequest): Promise<SearchResponse>;
	search_list(request: SearchRequest): Promise<SearchResponse>;
	search_task_create(request: SearchRequest): Promise<SearchTaskResponse>;
	search_task(requestId: string): Promise<SearchResponse>;
}

export type RequestQuery = {
	level?: "level_0" | "level_1" | "level_2" | "level_3";
	level_0_keys?: string;
	level_1_keys?: string;
	level_2_keys?: string;
	level_3_keys?: string;
};

export type SearchRequest = {
	source: "locations";
	geo_request: Array<RequestQuery>;
	level?: "" | "level_0" | "level_1" | "level_2";
};

export type SearchResponse = {
	status?: "COMPLETED" | "PROCESSING";
	geoResponse?: {
		/** Length of allLocations TODO */
		totalNumberDocs: number;
		allLocations: SearchResponseItem[];
	};
	error?: {
		code: number;
		message: string;
	};
};

export enum ResponseStatus {
	/** Results are provided in locations*/
	COMPLETED = "COMPLETED",
	/** Locations is an empty array */
	MULTIPLE_MATCHES = "MULTIPLE_MATCHES",
	PROCESSING = "PROCESSING",
	NO_MATCH = "NO_MATCH",
	// Custom stata
	ERROR = "ERROR",
}

export type LocationItem = {
	source: string;
	features: {
		latitude: number;
		longitude: number;
		level_0_name: string;
		level_1_name: string;
		level_2_name: string;
	};
	geometry: Geometry;
};

export type SearchResponseItem = {
	/** Original request query */
	request: RequestQuery;
	totalDocuments: number;
	status: ResponseStatus;
	locations: Array<LocationItem>;
	// used only when cached data transferred from shared worker
	validUntil?: number;
};

export type SearchTaskResponse = {
	requestId: string;
	startTime: number;
	status: ResponseStatus;
};
